import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './index.css';


function Navbar1() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container fluid className='mx-5 d-flex align-items-center'>
                <Navbar.Brand href="#" className='me-5'>Navbar scroll</Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    
                        <Form className="d-flex  flex-grow-1 me-3 reserachbar">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="me-2 flex-grow-1"
                                aria-label="Search"
                            />
                            <Button variant="outline-success">Search</Button>
                        </Form>
                        <Nav
                        className="ms-auto my-2 my-lg-0 fontde"
                        navbarScroll
                    >

                        <Nav.Link href="#action1">Home</Nav.Link>
                        <Nav.Link href="#action2">Contact</Nav.Link>
                        <Nav.Link href="#action2">Cell Course</Nav.Link>
                        <Nav.Link href="#action2">Success Storties</Nav.Link>
                        
                        
                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navbar1;